module.exports = {
	"id": "MW",
	"name": "Malawi",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.001187,
			"11": 0.020179,
			"12": null,
			"13": null,
			"14": 0.001187,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.001187,
			"19": 0.004748,
			"20": 0.001187,
			"21": 0.002374,
			"22": 0.002374,
			"23": 0.001187,
			"24": 0.002374,
			"25": null,
			"26": 0.007122,
			"27": 0.003561,
			"28": 0.007122,
			"29": 0.002374,
			"30": null,
			"31": 0.027301,
			"32": 0.014244,
			"33": 0.015431,
			"34": 0.002374,
			"35": 0.005935,
			"36": 0.007122,
			"37": 0.002374,
			"38": 0.003561,
			"39": 0.007122,
			"40": 0.033236,
			"41": 0.002374,
			"42": 0.013057,
			"43": 0.033236,
			"44": 0.003561,
			"45": 0.020179,
			"46": 0.024927,
			"47": 0.027301,
			"48": 0.024927,
			"49": 0.175676,
			"50": 0.056976,
			"51": 0.128196,
			"52": 0.097334,
			"53": 2.70636,
			"54": 0.542459,
			"55": 0.01187,
			"56": 0.005935,
			"57": null
		},
		"firefox": {
			"2": 0.002374,
			"3": 0.099708,
			"4": 0.004748,
			"5": 0.004748,
			"6": null,
			"7": 0.002374,
			"8": 0.003561,
			"9": 0.005935,
			"10": 0.01187,
			"11": 0.005935,
			"12": 0.036797,
			"13": 0.015431,
			"14": 0.016618,
			"15": 0.01187,
			"16": 0.009496,
			"17": 0.005935,
			"18": 0.005935,
			"19": 0.020179,
			"20": 0.013057,
			"21": 0.015431,
			"22": 0.013057,
			"23": 0.010683,
			"24": 0.010683,
			"25": 0.007122,
			"26": 0.013057,
			"27": 0.008309,
			"28": 0.005935,
			"29": 0.032049,
			"30": 0.039171,
			"31": 0.014244,
			"32": 0.016618,
			"33": 0.007122,
			"34": 0.022553,
			"35": 0.039171,
			"36": 0.01187,
			"37": 0.029675,
			"38": 0.030862,
			"39": 0.018992,
			"40": 0.033236,
			"41": 0.115139,
			"42": 0.020179,
			"43": 0.134131,
			"44": 0.084277,
			"45": 0.067659,
			"46": 0.036797,
			"47": 0.378653,
			"48": 0.290815,
			"49": 1.484937,
			"50": 0.235026,
			"51": 0.009496,
			"52": null,
			"3.5": null,
			"3.6": 0.004748
		},
		"opera": {
			"9": null,
			"11": 0.004748,
			"12": 0.003561,
			"15": null,
			"16": 0.002374,
			"17": 0.001187,
			"18": 0.001187,
			"19": 0.002374,
			"20": 0.007122,
			"21": 0.009496,
			"22": 0.004748,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": 0.013057,
			"28": 0.003561,
			"29": 0.007122,
			"30": 0.003561,
			"31": 0.003561,
			"32": 0.007122,
			"33": 0.008309,
			"34": 0.015431,
			"35": 0.02374,
			"36": 0.015431,
			"37": 0.172115,
			"38": 0.014244,
			"39": 0.052228,
			"40": 0.26114,
			"41": 0.022553,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": 0.003561,
			"11.6": 0.005935,
			"12.1": 0.015431
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.007122,
			"6": 0.001187,
			"7": 0.02374,
			"8": 0.027301,
			"9": 0.027301,
			"10": 0.064098,
			"3.1": null,
			"3.2": null,
			"5.1": 0.014244,
			"6.1": 0.002374,
			"7.1": 0.010683,
			"9.1": 0.072407
		},
		"ios_saf": {
			"8": 0,
			"10": 0.590404957535,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.015910730433,
			"8.1-8.4": 0.0293944002914,
			"9.0-9.2": 0.0140230166528,
			"9.3": 0.213940895087
		},
		"android": {
			"3": 0,
			"4": 0.0551552609819,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00689440762274,
			"4.1": 0.198952905685,
			"4.2-4.3": 0.497382264212,
			"4.4": 1.14053200388,
			"4.4.3-4.4.4": 1.15038115762
		},
		"ie": {
			"6": 0.002374,
			"7": 0.003561,
			"8": 0.274197,
			"9": 0.081903,
			"10": 0.098521,
			"11": 1.308074,
			"5.5": null
		},
		"op_mob": {
			"0": 3.43814240187,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0955039556074
		},
		"edge": {
			"12": 0.235026,
			"13": 0.127009,
			"14": 0.086651
		},
		"ie_mob": {
			"10": 0.64992771831,
			"11": 2.64613428169
		},
		"bb": {
			"7": 0.30184525,
			"10": null
		},
		"samsung": {
			"0": 1.048747
		},
		"and_uc": {
			"0": 22.393833
		},
		"op_mini": {
			"0": 46.3214946425
		},
		"and_chr": {
			"0": 5.579887
		},
		"and_ff": {
			"0": 0.026439
		}
	},
	"total": 97.13709725
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/MW.json
 ** module id = 600
 ** module chunks = 0
 **/